import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowIcon({ width = 14, height = 10.2, color = '#3F4750' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7 1.1999C13.3 0.799902 12.7 0.799902 12.3 1.1999L4.8 8.6999L1.7 5.5999C1.3 5.1999 0.7 5.1999 0.3 5.5999C-0.1 5.9999 -0.1 6.5999 0.3 6.9999L4.1 10.7999C4.3 10.9999 4.5 11.0999 4.8 11.0999C5.1 11.0999 5.3 10.9999 5.5 10.7999L13.7 2.5999C14.1 2.1999 14.1 1.5999 13.7 1.1999Z"
        fill={color}
      />
    </svg>
  );
}

ArrowIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
